"use client";

import { Button } from "@workspace/ui/components/button";
import { EventNames, SectionTypes, sendEvent, withSectionType } from "@/lib/utils/analytics";

const CTA_TEXT = "How does it work?";
const CTA_SCROLL_TARGET = "how-it-works";

/** Some section ids exist twice (mobile + desktop); scroll to the visible one. */
function getVisibleSectionById(sectionId: string): HTMLElement | null {
  const candidates = Array.from(
    document.querySelectorAll<HTMLElement>(`[id="${sectionId}"]`),
  );

  return (
    candidates.find((candidate) => {
      if (candidate.getClientRects().length === 0) return false;
      const style = window.getComputedStyle(candidate);
      return style.display !== "none" && style.visibility !== "hidden";
    }) ??
    candidates[0] ??
    null
  );
}

export function HeroCtaPrecision() {
  function handleClick() {
    sendEvent(
      EventNames.HOW_INITO_WORK_CLICKED,
      withSectionType(SectionTypes.HERO_BANNER),
    );
    const el = getVisibleSectionById(CTA_SCROLL_TARGET);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 40;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }

  return (
    <Button
      id="hero-cta"
      data-testid="hero-cta"
      variant="white"
      size="default"
      className="w-fit self-start lg:rounded-[14px] lg:px-[30px] lg:py-[15px] lg:title-18"
      onClick={handleClick}
    >
      {CTA_TEXT}
    </Button>
  );
}
